import axios from "axios";

export const deleteShipmentInvoiceApi = async (invoiceId, lang, cookies) => {
  const token = cookies.__t0ken_amar_management;

  let config = {
    method: "delete",
    url: `${process.env.REACT_APP_API}/delete-shipment-invoice/${invoiceId}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
